interface DividerLineProps {
  position?: 'above' | 'below'
}

export function DividerLine({ position = 'below' }: DividerLineProps) {
  const baseClasses =
    'absolute left-1/2 z-10 h-4 w-px -translate-x-1/2 bg-gray-300'

  const positionClass = position === 'above' ? '-top-4' : 'top-full'

  return <div className={`${baseClasses} ${positionClass}`} />
}
